import { Inject, Injectable } from '@angular/core';
import { MicrosoftTeamsToken, MSTeamsToken } from '@app/ms-teams/msteams.token';
import { authentication, HostClientType } from '@microsoft/teams-js';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const NAV_ENTITY_ID_PREFIX = 'com.degreed.app.';

@Injectable({ providedIn: 'root' })
export class MSTeamsService {
  constructor(
    @Inject(MicrosoftTeamsToken) private microsoftTeams: MSTeamsToken
  ) {}

  public getAuthToken(): Observable<string> {
    return from(authentication.getAuthToken());
  }

  public getHostApp(): Observable<HostClientType> {
    return from(this.microsoftTeams.getContext()).pipe(
      map((context) => {
        return context.app.host.clientType;
      })
    );
  }

  public getLocale(): Observable<string> {
    return from(this.microsoftTeams.getContext()).pipe(
      map((context) => {
        return context.app.locale;
      })
    );
  }

  public getCurrentTab(): Observable<string> {
    return from(this.microsoftTeams.getContext()).pipe(
      map((context) => {
        const entityId = context.page.id.replace(NAV_ENTITY_ID_PREFIX, '');
        return entityId === 'search' ? 'learning/search' : entityId;
      })
    );
  }

  public getActivityFeedNotification(): Observable<
    string | Record<string, string>
  > {
    return from(this.microsoftTeams.getContext()).pipe(
      map((context) => {
        return context.page.subPageId;
      })
    );
  }

  public getContext() {
    return from(this.microsoftTeams.getContext());
  }

  public isInitialized(): boolean {
    return this.microsoftTeams.isInitialized();
  }

  public initialize(): Promise<void> {
    return this.microsoftTeams.initialize();
  }

  public notifySuccess(): void {
    this.microsoftTeams.notifySuccess();
  }

  public async initializeAndNotifySuccess(): Promise<void> {
    await this.initialize();
    this.notifySuccess();
  }
}
